import { CsbHelper, getConfig, getTemplateValues } from '@recruiting-solutions/rs-shared';
import { Component, Host, h } from '@stencil/core';
import { ArvIcons } from 'apps/arv-components/src/global/arv-icons';
import { ArvButtonAnimated } from '../arv-button-animated/arv-button-animated';
import { IAnimatedButtonIconParams, asSans12, asSans16, whiteWhiteNoBG } from '../arv-button-animated/arv-button-animated-params';

const i18n = getTemplateValues('footer');
@Component({
    tag: 'arv-footer',
    styleUrl: 'arv-footer.scss',
    shadow: true,
})
export class ArvFooter {
    componentWillLoad() {
        const footerElement = document.getElementById('footer');
        if (footerElement) {
            footerElement.style.display = 'none';
        }
    }
    render() {
        const phone = i18n('phone');
        const iconThemeEmail: IAnimatedButtonIconParams = { name: 'email', color: 'white', direction: 'left', className: 'icon', size: 14 };
        const iconThemePhone: IAnimatedButtonIconParams = { name: 'phone', color: 'white', direction: 'left', className: 'icon', size: 14 };
        const isStageEnvironment: boolean = getConfig().storageUrl.includes('staging');
        const privacyUrl = i18n(isStageEnvironment ? 'urlPrivacySTAGE' : 'urlPrivacyPROD');

        let logoName = 'logo1';
        let linkImp = 'https://arvato.com/impressum';
        let reportViolations = '';
        let reportViolationsLink = '';

        let imprint = 'Imprint';
        let cookies = 'Cookies';
        let corporate = 'Corporate Website';
        let corporateUrl = 'https://arvato.com/';
        let privacy = 'Privacy Policy';

        switch (CsbHelper.getLocale()) {
            case 'de_DE':
                logoName = 'logo1';
                linkImp = 'https://arvato.com/impressum';

                imprint = 'Impressum';
                corporate = 'Corporate Website';
                corporateUrl = 'https://arvato.com/de';
                privacy = 'Datenschutz';
                break;

            case 'en_US':
                logoName = 'logo1_en_US';
                linkImp = 'https://arvato.com/imprint';
                break;

            case 'pl_PL':
                logoName = 'logo1_pl_PL';
                linkImp = 'https://arvato.com/pl/stopka-redakcyjna';
                reportViolations = 'Zgłaszanie naruszeń';
                reportViolationsLink = 'https://arvato.com/fileadmin/user_upload/Arvato/Website/Landingpages/Countries/PL/Ustawa-o-ochronie-sygnalistow.pdf';
                cookies = 'Pliki cookie';

                imprint = 'Stopka redakcyjna';
                corporate = 'Strona korporacyjna';
                corporateUrl = 'https://arvato.com/pl';
                privacy = 'Polityka prywatności';
                break;

            case 'nl_NL':
                logoName = 'logo1_nl_NL';
                linkImp = 'https://arvato.com/nl/afdruk';

                imprint = 'Impressum';
                corporate = 'Bedrijfswebsite';
                corporateUrl = 'https://arvato.com/nl';
                privacy = 'Privacy';
                break;

            case 'it_IT':
                logoName = 'logo1_it_IT';
                linkImp = 'https://arvato.com/it/impronta';

                imprint = 'Impronta';
                corporate = 'Sito web aziendale';
                corporateUrl = 'https://arvato.com/it';
                privacy = 'Privacy';
                break;

            case 'tr_TR':
                logoName = 'logo1_tr_TR';
                linkImp = 'https://arvato.com/tr/kunye';
                cookies = 'Çerezler';

                imprint = 'Künye';
                corporate = 'Kurumsal Web Sitesi';
                corporateUrl = 'https://arvato.com/tr';
                privacy = 'Veri koruması';
                break;

            case 'es_ES':
                logoName = 'logo1_es_ES';
                linkImp = 'https://arvato.com/es/pie-de-imprenta';

                imprint = 'Pie de imprenta';
                corporate = 'Sitio web corporativo';
                corporateUrl = 'https://arvato.com/es';
                privacy = 'Política de privacidad';
                break;

            case 'fr_FR':
                logoName = 'logo1_fr_FR';
                linkImp = 'https://arvato.com/fr/impression';

                imprint = 'Impression';
                corporate = `Site web de l'entreprise`;
                corporateUrl = 'https://arvato.com/fr';
                privacy = 'Politique de confidentialité';
                break;

            case 'pt_BR':
                logoName = 'logo1_pt_BR';
                linkImp = 'https://arvato.com/pt/impressao';

                imprint = 'Aviso legal';
                corporate = 'Site corporativo';
                corporateUrl = 'https://arvato.com/pt';
                privacy = 'Proteção de dados';
                break;
        }
        return (
            <Host>
                <div class="background" role="contentinfo">
                    <div class="top">
                        <div class="grid">
                            <div class="column">{ArvIcons.getLogo(logoName, 'white', 'white', 120, 48, 'icon')}</div>
                            <div class="column"></div>
                            <div class="column">
                                <h2>{i18n('title')}</h2>
                                <p>{i18n('desc')}</p>
                                {ArvButtonAnimated.asHref(i18n('email'), 'mailto:' + i18n('email'), '', whiteWhiteNoBG(), asSans16(), iconThemeEmail)}
                                {phone && ArvButtonAnimated.asHref(i18n('phone'), 'tel:' + i18n('phone')?.replace(/ /gi, '-'), '', whiteWhiteNoBG(), asSans16(), iconThemePhone)}
                                <div class="social-icons">
                                    <a href={i18n('urlLinkedIn')} title={i18n('linkedInTitle')} target="_blank" class="social">
                                        {ArvIcons.getGeneric('linkedin', 'white', 32, 'socials-svg')}
                                    </a>
                                    <a href={i18n('urlInstagram')} title={i18n('instagramTitle')} target="_blank" class="social">
                                        {ArvIcons.getGeneric('instagram', 'white', 32, 'socials-svg')}
                                    </a>
                                    <a href={i18n('urlYoutube')} title={i18n('youtubeTitle')} target="_blank" class="social">
                                        {ArvIcons.getGeneric('youtube', 'white', 32, 'socials-svg')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="linedivider"></div>
                    <div class="bottom">
                        <div class="grid">
                            {ArvButtonAnimated.asHref(imprint, linkImp, '', whiteWhiteNoBG(), asSans12())}
                            {ArvButtonAnimated.asHref(privacy, privacyUrl, '', whiteWhiteNoBG(), asSans12())}
                            {CsbHelper.getLocale() === 'pl_PL' && ArvButtonAnimated.asHref(reportViolations, reportViolationsLink, '', whiteWhiteNoBG(), asSans12())}
                            {ArvButtonAnimated.asHref(corporate, corporateUrl, '', whiteWhiteNoBG(), asSans12())}
                            <div onClick={() => this.openCookie()}>{ArvButtonAnimated.asHref(cookies, '#cookie-bannershow', '', whiteWhiteNoBG(), asSans12())}</div>
                            {/* {ArvButtonAnimated.asButton('Cookies', whiteWhiteNoBG(), asSans12(), null, () => this.openCookie())} */}
                        </div>
                        <div class="copyright">Copyright {new Date().getFullYear()} Arvato SE</div>
                    </div>
                </div>
            </Host>
        );
    }
    openCookie(): void {
        //(window as any).jQuery && (window as any).jQuery('.ukCookiePolicy').show() //does not work anymore?
        const el = document.querySelector('.cookiePolicy') as HTMLDivElement;
        if (el) {
            el.style.display = 'block';
        }
    }
}
